import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { DdqSession } from '@/types/api.types';

interface SessionListState {
  sessions: DdqSession[];
  isLoading: boolean;
  error: string | null;

  // Actions
  setSessions: (sessions: DdqSession[]) => void;
  addSession: (session: DdqSession) => void;
  removeSession: (sessionId: string) => void;
  updateSession: (sessionId: string, updates: Partial<DdqSession>) => void;
  clearSessions: () => void;
  setError: (error: string | null) => void;
  setLoading: (isLoading: boolean) => void;
}

export const useSessionListStore = create<SessionListState>()(
  persist(
    (set) => ({
      sessions: [],
      isLoading: false,
      error: null,

      setSessions: (sessions) => set({ sessions }),

      setLoading: (isLoading) => set({ isLoading }),

      addSession: (session) =>
        set((state) => ({
          sessions: [session, ...state.sessions],
        })),

      removeSession: (sessionId) =>
        set((state) => ({
          sessions: state.sessions.filter((s) => s.id !== sessionId),
        })),

      updateSession: (sessionId, updates) =>
        set((state) => ({
          sessions: state.sessions.map((s) =>
            s.id === sessionId ? { ...s, ...updates } : s
          ),
        })),

      clearSessions: () => set({ sessions: [] }),

      setError: (error) => set({ error }),
    }),
    {
      name: 'insight-sessions',
      partialize: (state) => ({ sessions: state.sessions }),
    }
  )
);
